module.exports = __webpack_public_path__ + "img/brick-rect.4ca6dcb3.svg";